module.exports = __webpack_public_path__ + "static/media/android.477b0618.png";